function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u7FA4\\u7D44",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(1.500000, 1.500000)",
  fill: "#555555",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.500000, 4.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0 C8.55228475,0 9,0.44771525 9,1 L9,8 C9,8.55228475 8.55228475,9 8,9 L1,9 C0.44771525,9 0,8.55228475 0,8 L0,1 C0,0.44771525 0.44771525,0 1,0 L8,0 Z M7,2 L2,2 L2,7 L7,7 L7,2 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,3 C11.5522847,3 12,3.44771525 12,4 L12,11 C12,11.5522847 11.5522847,12 11,12 L4,12 C3.44771525,12 3,11.5522847 3,11 L3,4 C3,3.44771525 3.44771525,3 4,3 L11,3 Z M10,5 L5,5 L5,10 L10,10 L10,5 Z",
  id: "Rectangle-Copy"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.4985888,17.5 L16.4985888,19.5 L4.51801509,19.5 L4.51801509,17.5 L16.4985888,17.5 Z M19.5,4.53209439 L19.5,16.5411152 L17.5,16.5411152 L17.5,4.53209439 L19.5,4.53209439 Z M3.5,4.52088796 L3.5,16.5160642 L1.5,16.5160642 L1.5,4.52088796 L3.5,4.52088796 Z M16.5407015,1.5 L16.5407015,3.5 L4.51946177,3.5 L4.51946177,1.5 L16.5407015,1.5 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5,0 C19.8807119,0 21,1.11928813 21,2.5 C21,3.88071187 19.8807119,5 18.5,5 C17.1192881,5 16,3.88071187 16,2.5 C16,1.11928813 17.1192881,0 18.5,0 Z M18.5,2 C18.2238576,2 18,2.22385763 18,2.5 C18,2.77614237 18.2238576,3 18.5,3 C18.7761424,3 19,2.77614237 19,2.5 C19,2.22385763 18.7761424,2 18.5,2 Z",
  id: "Oval"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5,0 C3.88071187,0 5,1.11928813 5,2.5 C5,3.88071187 3.88071187,5 2.5,5 C1.11928813,5 0,3.88071187 0,2.5 C0,1.11928813 1.11928813,0 2.5,0 Z M2.5,2 C2.22385763,2 2,2.22385763 2,2.5 C2,2.77614237 2.22385763,3 2.5,3 C2.77614237,3 3,2.77614237 3,2.5 C3,2.22385763 2.77614237,2 2.5,2 Z",
  id: "Oval-Copy-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5,16 C19.8807119,16 21,17.1192881 21,18.5 C21,19.8807119 19.8807119,21 18.5,21 C17.1192881,21 16,19.8807119 16,18.5 C16,17.1192881 17.1192881,16 18.5,16 Z M18.5,18 C18.2238576,18 18,18.2238576 18,18.5 C18,18.7761424 18.2238576,19 18.5,19 C18.7761424,19 19,18.7761424 19,18.5 C19,18.2238576 18.7761424,18 18.5,18 Z",
  id: "Oval-Copy"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5,16 C3.88071187,16 5,17.1192881 5,18.5 C5,19.8807119 3.88071187,21 2.5,21 C1.11928813,21 0,19.8807119 0,18.5 C0,17.1192881 1.11928813,16 2.5,16 Z M2.5,18 C2.22385763,18 2,18.2238576 2,18.5 C2,18.7761424 2.22385763,19 2.5,19 C2.77614237,19 3,18.7761424 3,18.5 C3,18.2238576 2.77614237,18 2.5,18 Z",
  id: "Oval-Copy-3"
})));

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7FA4\u7D44") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.7a9da7bf.svg";
export { ForwardRef as ReactComponent };